
export default function XIcon({size=40}:{
    size?:number
}) {
    return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="8" fill="black"/>
        <path
            d="M16 10H9L17.2609 21.0145L9.44995 29.9999H12.1L18.4883 22.651L24 30H31L22.3917 18.5223L29.8001 10H27.1501L21.1643 16.8858L16 10ZM25 28L13 12H15L27 28H25Z"
            fill="white"/>
    </svg>

}